import { useActivityStore } from '@/stores/activity'
export async function loggedIn() {
  await useActivityStore().fetchActivityTypes()
}
